// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// https://10.169.45.26:8065 - SVIL FINDOMESTIC - API GATEWAY
// http://10.169.45.13:81 - SVIL FINDOMESTIC - JAVA LAYER - SVIL
// http://10.169.45.15:81 - SVIL FINDOMESTIC - JAVA LAYER - UAT

export const environment = {
  production: false,
  name:'devDir',
  //name:'svilDir',
  //apiUrl:'https://10.50.201.213',
  // apiUrl: 'http://10.169.45.15:81',
  apiUrl: 'https://apis-it.staging.bnpparibas-pf.com',
  // apiUrl: 'http://10.169.45.13:85',
  logLevel:0,
  hasRemote:false,
  remoteLogUrl:'',
};
